var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"height":_vm.height,"src":_vm.$store.getters['Landing/company'].logo,"contain":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }